/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Blossom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Blossom"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#4485DA"
        d="M12 2c1.264 0 2.333 1.47 2.694 3.497 1.688-1.179 3.484-1.462 4.377-.568.894.893.61 2.688-.569 4.377C20.53 9.666 22 10.736 22 12s-1.47 2.334-3.498 2.694c1.179 1.688 1.463 3.484.57 4.377-.895.894-2.69.61-4.378-.569C14.334 20.53 13.264 22 12 22s-2.334-1.47-2.694-3.498c-1.688 1.178-3.484 1.462-4.377.57-.894-.894-.61-2.69.568-4.378C3.47 14.334 2 13.264 2 12s1.47-2.334 3.497-2.694c-1.178-1.688-1.461-3.484-.568-4.377s2.689-.61 4.377.567C9.666 3.47 10.736 2 12 2"
      />
      <path
        fill="#FFC220"
        d="M14.727 12a2.727 2.727 0 1 1-5.454 0 2.727 2.727 0 0 1 5.454 0"
      />
    </g>
  </svg>
);

export const BlossomIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'blossom-icon'}
      icon={Blossom}
      {...props}
      size={size}
    />
  );
};
